import { render, staticRenderFns } from "./editarDatos.vue?vue&type=template&id=089d5b41&scoped=true&"
import script from "./editarDatos.vue?vue&type=script&lang=js&"
export * from "./editarDatos.vue?vue&type=script&lang=js&"
import style0 from "./editarDatos.vue?vue&type=style&index=0&id=089d5b41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d5b41",
  null
  
)

export default component.exports